<div class="container">
    <section>
        <div class="row">
            <div class="col-md-8 col-md-offset-2 text-center">
                <i class="icono-arg-tristeza icono-5x text-warning"></i>
                <h1><br>Página no encontrada</h1>
                <p class="lead margin-40">La dirección web no está bien escrita o fue dada de baja.</p>
                <p class="margin-60"><a routerLink="/" class="btn btn-primary">Ir la página de inicio</a>
                </p>
            </div>
        </div>
    </section>
</div>